import get from 'lodash/get';
import {
    SET_AUTH,
    SET_LOGIN_ERROR,
    SET_CLIENT_PERSONAL,
    FETCH_CLIENT_PAYMENT,
    SET_CLIENT_PAYMENT,
    ERROR_CLIENT_PAYMENT,
    SET_CLIENT_PRODUCTS,
    SET_ACCESS_TOKEN,
    SET_REFRESH_TOKEN,
    SET_BILLING_DOMAIN,
    INVALID_LOGIN,
    CLEAR_INVALID_LOGIN,
    CLIENT_PRODUCTS_LOADING,
    SET_CONTRACT_PERIOD,
    SET_RECEIPT_INFO,
    SET_CLIENT_CONTACTS,
    CLIENT_CONTACTS_LOADING
} from '../actionTypes/auth';
import {
    ACCESS_TOKEN_COOKIE,
    REFRESH_TOKEN_COOKIE,
    LK_PHPSESSID,
    COOKIE_MAX_AGE_SHORT,
    COOKIE_MAX_AGE_LONG,
    WRONG_LOGIN_COUNT_COOKIE,
    CITYDOMAIN_COOKIE,
    BILLINGDOMAIN_COOKIE,
    PRODUCT_TYPE_COOKIE,
    BILLING_GET_INFO,
    COOKIE_DOMAIN,
    IS_PRODUCTION_ENVIROMENT,
    AGREEMENT_ID_COOKIE,
} from '../../constants/index';
import * as authAPI from '../../api/auth';
import cookie from 'react-cookies';
import { changeUrlCity, isLkReferrer } from '../../helpers/url';
import profileRequest
    from '@ertelecom/ui-react/components/requests/profileRequest';
import { billingXMLGetRequest } from '@ertelecom/ui-react/components/requests/billingRequest';
import { changeCity, isDevDomain } from '~/src/helpers/city';
import { isServerSide, isClientSide } from '~/src/helpers/ssr';
import { getPaymentInfo } from '~/src/api/profile/getPaymentInfo';
import { getProductsInfo } from '~/src/api/profile/getProductsInfo';
import { catch401 } from '~/src/store/actions/helpers';
import { selectDomain } from '~/src/store/selectors/domain';
import { captureMessage, captureException } from '@sentry/node';
import { getContractPeriod, getPenaltySum } from '~/src/api/internet';
import { getReceiptJSON } from '~/src/api/profile/getReceipt';
import { getContacts } from '~/src/api/profile/getContacts';
import { getCityInfo } from '~/src/api/content/geography/get-city-info';

const setInvalidLogin = () => ({
    type: INVALID_LOGIN,
});

export const clearInvalidLogin = () => ({
    type: CLEAR_INVALID_LOGIN,
});

const setAuth = isAuth => ({
    type: SET_AUTH,
    payload: isAuth,
});

const setToken = token => ({
    type: SET_ACCESS_TOKEN,
    payload: token || '',
});

const setRefreshToken = refreshToken => ({
    type: SET_REFRESH_TOKEN,
    payload: refreshToken,
});

const setLoginError = error => ({
    type: SET_LOGIN_ERROR,
    payload: error,
});

const setClientPersonal = (data) => ({
    type: SET_CLIENT_PERSONAL,
    payload: data,
});

export const setClientPayment = data => ({
    type: SET_CLIENT_PAYMENT,
    payload: data,
});

const setClientProducts = data => ({
    type: SET_CLIENT_PRODUCTS,
    payload: data,
});

const setClientContacts = data => ({
    type: SET_CLIENT_CONTACTS,
    payload: data
});

const clientContactsLoading = (isLoading) => ({
    type: CLIENT_CONTACTS_LOADING,
    payload: isLoading,
});

const clientProductsLoading = (isLoading) => ({
    type: CLIENT_PRODUCTS_LOADING,
    payload: isLoading,
});

const setBillingDomain = data => ({
    type: SET_BILLING_DOMAIN,
    payload: data,
});

const setContractPeriods = data => ({
    type: SET_CONTRACT_PERIOD,
    payload: data
});

const setReceiptInfo = data => ({
    type: SET_RECEIPT_INFO,
    payload: data
});


export const setTokenCookie = (token, rememberMe, response) => {
    const cookieConfig = {
        maxAge: rememberMe ? COOKIE_MAX_AGE_LONG : COOKIE_MAX_AGE_SHORT,
        domain: COOKIE_DOMAIN,
        path: '/',
    };

    if (isServerSide()) {
        response.cookie(ACCESS_TOKEN_COOKIE, token, cookieConfig);
    } else {
        cookie.save(ACCESS_TOKEN_COOKIE, token, cookieConfig);
    }
};

const setAccessTokenCookie = (token, rememberMe) => {
    return dispatch => {
        const cookieConfig = {
            maxAge: rememberMe ? COOKIE_MAX_AGE_LONG : COOKIE_MAX_AGE_SHORT,
            domain: COOKIE_DOMAIN,
            path: '/',
        };
        cookie.save(ACCESS_TOKEN_COOKIE, token, cookieConfig);
        dispatch(setToken(token));
    };
};

const setRefreshTokenCookie = (refreshToken, rememberMe) => {
    return dispatch => {
        const cookieConfig = {
            maxAge: rememberMe ? COOKIE_MAX_AGE_LONG : COOKIE_MAX_AGE_SHORT,
            domain: COOKIE_DOMAIN,
            path: '/',
        };
        cookie.save(REFRESH_TOKEN_COOKIE, refreshToken, cookieConfig);
        dispatch(setRefreshToken(refreshToken));
    };
};

/**
 * @param {string} billingDomain
 * @param {Response|null} [response] express
 * @return {function(*): void}
 */
const setBillingDomainCookie = (billingDomain, response) => {
    return dispatch => {
        if (['msk', 'rinet'].includes(billingDomain)) {
            const cookieConfig = {
                maxAge: COOKIE_MAX_AGE_LONG,
                domain: COOKIE_DOMAIN,
                path: '/',
            };
            if (isServerSide()) {
                response.cookie(BILLINGDOMAIN_COOKIE, billingDomain, cookieConfig);
            } else {
                cookie.save(BILLINGDOMAIN_COOKIE, billingDomain, cookieConfig);
            }
            dispatch(setBillingDomain(billingDomain));
        } else {
            const cookieConfig = {
                domain: COOKIE_DOMAIN,
                path: '/',
            };
            if (isServerSide()) {
                response.clearCookie(BILLINGDOMAIN_COOKIE, cookieConfig);
            } else {
                cookie.remove(BILLINGDOMAIN_COOKIE, cookieConfig);
            }
        }
    };
};

export const setCityDomainCookie = (authDomain, rememberMe, response) => {
    const cookieConfig = {
        maxAge: rememberMe ? COOKIE_MAX_AGE_LONG : COOKIE_MAX_AGE_SHORT,
        domain: COOKIE_DOMAIN,
        path: '/',
    };

    if (isServerSide()) {
        response.cookie(CITYDOMAIN_COOKIE, authDomain, cookieConfig);
    } else {
        cookie.save(CITYDOMAIN_COOKIE, authDomain, cookieConfig);
    }
};

const cookieKeys = [
    ACCESS_TOKEN_COOKIE,
    REFRESH_TOKEN_COOKIE,
    LK_PHPSESSID,
    PRODUCT_TYPE_COOKIE,
    BILLINGDOMAIN_COOKIE,
    AGREEMENT_ID_COOKIE,
    CITYDOMAIN_COOKIE,
];

/**
 * @param {Response} res express response
 */
 function clearCookieServerSide(res) {
    const cookieConfig = {
        domain: COOKIE_DOMAIN,
        path: '/',
    };

    cookieKeys.forEach((key) => {
        res.clearCookie(key, cookieConfig);
    });
}

function clearCookie() {
    const cookieConfig = {
        domain: COOKIE_DOMAIN,
        path: '/',
    };

    cookieKeys.forEach(function(item) {
        cookie.remove(item, cookieConfig);
    });
}

/**
 * @param {string}  username
 * @param {string}  password
 * @param {boolean} rememberMe
 * @param {string}  referrer
 * @param {string}  domain
 * @return {Promise<void>}
 */
export function login(username, password, rememberMe, referrer, domain) {
    return (dispatch, getState) => {
        const state = getState();
        const authDomain = domain ? domain : state.city.currentCity.domain;
        // обход запроса капчи от бэка, если перешли с пхпшной страницы
        cookie.save(WRONG_LOGIN_COUNT_COOKIE, 0);
        const nowDomain = state.city.currentCity.domain;

        return authAPI
            .login(username, password, rememberMe, authDomain)
            .then(response => {
                const result = response.data;
                const accessToken = get(result, 'data.access_token', '');
                dispatch(setAccessTokenCookie(accessToken, rememberMe));
                const refreshToken = get(result, 'data.refresh_token', '');
                dispatch(setRefreshTokenCookie(refreshToken, rememberMe));
                const billingDomain = get(result, 'data.billing_domain');
                dispatch(setBillingDomainCookie(billingDomain));

                cookie.save(WRONG_LOGIN_COUNT_COOKIE, 0);

                if (nowDomain === authDomain && !referrer) {
                    setCityDomainCookie(authDomain, rememberMe);
                    dispatch(setAuth(true));
                    dispatch(setLoginError(''));
                    dispatch(getClientAll());
                } else if (referrer) {
                    if (~referrer.indexOf('http')) {
                        // если переход на другой ресурс
                        setCityDomainCookie(authDomain, rememberMe);
                        location.href = referrer;
                    } else {
                        if (isLkReferrer(referrer)) {
                            referrer = null;
                        }
                        // если есть куда перейти на текущем сайте но может
                        // смениться город (приоритет города авторизации)
                        changeUrlCity(
                            authDomain,
                            referrer,
                            rememberMe,
                        );
                    }
                } else {
                    // если просто сменился городе перейдем на него
                    changeCity(authDomain);
                }

                return response;
            })
            .catch(error => {
                const errorMessage = get(error, 'response.data.message', '');
                dispatch(setLoginError(errorMessage));
                const statusCode = get(error, 'response.status');
                if (statusCode === 400) {
                    dispatch(setInvalidLogin());
                }
                return error.response;
            });
    };
}

/**
 * @param {Response} [res] express response
 */
export function logout(res) {
    return async dispatch => {

        if (isServerSide() && res == null) {
            captureMessage('функция auth.logout была вызвана без параметра Response на серверной стороне', 'error');
            console.error('функция auth.logout была вызвана без параметра Response на серверной стороне');
        }

        if (res) {
            clearCookieServerSide(res);
        } else {
            clearCookie();
        }

        dispatch(setAuth(false));
        dispatch(setToken(''));
        dispatch(setRefreshToken(''));
        dispatch(setBillingDomain(''));
    };
}

/**
 * @param {string} accessToken
 * @param {string} billingDomain
 * @param {Response} response express response
 * @return {function(*=): Promise<undefined>}
 */
export function loginByAccessToken(accessToken, billingDomain, response) {
    return async(dispatch) => {
        try {
            await Promise.all([
                dispatch(setToken(accessToken)),
                dispatch(setAuth(true)),
                dispatch(setBillingDomainCookie(billingDomain, response)),
            ]);
            await Promise.all([
                dispatch(getClientPersonal(response)),
                dispatch(getClientPayment(response)),
                dispatch(getClientProducts(response)),
                dispatch(getClientContacts()),
                dispatch(setLoginError('')),
            ]);
        } catch (e) {
            if (catch401(dispatch, e, response)) {
                return;
            }

            captureException(e);
        }
    };
}

export function getClientAll() {
    return (dispatch, getState) => {
        const state = getState();

        if (state.auth.isAuth === true) {
            dispatch(getClientPersonal());
            dispatch(getClientPayment());
            dispatch(getClientProducts());
            dispatch(getClientContacts());
        }
    };
}

function saveUserIdCookie(agreement, response) {
    const options = {
        domain: IS_PRODUCTION_ENVIROMENT ? '.dom.ru' : '.t2.ertelecom.ru',
    };

    if (response) {
        // server side
        response.cookie(AGREEMENT_ID_COOKIE, agreement, options);
    } else {
        cookie.save(AGREEMENT_ID_COOKIE, agreement, options);
    }
}

/**
 * @param {Response} [response] express
 * @return {function(*, *): (*|undefined)}
 */
export function getClientPersonal(response) {
    return (dispatch, getState) => {
        const state = getState();
        if (state.auth.isAuth === true) {
            const currentDomain = selectDomain(state);

            return profileRequest(
                currentDomain,
                state.auth.accessToken,
            ).get('/info/personal').then(async(res) => {
                dispatch(setClientPersonal(res.data));

                if (!isDevDomain(currentDomain) && res.data.cityId) {
                    const cityInfo = await getCityInfo({ city_id: res.data.cityId });
                    dispatch(setBillingDomain(cityInfo?.data?.domain));
                }

                saveUserIdCookie(res.data.agreement, response);

                if (isClientSide()) {
                    localStorage.setItem(
                        'clientServPersonal',
                        JSON.stringify(res.data),
                    );
                }
            }).catch(e => {
                if (catch401(dispatch, e, response)) {
                    return;
                }

                captureException(e);
            });
        }
    };
}

const CLIENT_PAYMENT_THRESHOLD = 60000;

/**
 * @param {Response} [response] express
 * @return {function(...[*]=)}
 */
export function getClientPayment(response) {
    return async function(dispatch, getState) {
        const state = getState();

        if (state.auth.isAuth !== true) {
            return;
        }

        const clientPaymentLoaded = state.auth.clientPaymentLoaded;
        if (clientPaymentLoaded) {
            const now = (new Date()).getTime();
            if ((now - clientPaymentLoaded) > CLIENT_PAYMENT_THRESHOLD) {
                return;
            }
        }

        dispatch({
            type: FETCH_CLIENT_PAYMENT,
        });

        try {

            const domain = selectDomain(state);
            const accessToken = state.auth.accessToken;
            const paymentInfo = await getPaymentInfo(domain, accessToken, { floatRecSum: 1 });

            dispatch(setClientPayment(paymentInfo));

        } catch (e) {
            dispatch({
                type: ERROR_CLIENT_PAYMENT,
            });

            if (catch401(dispatch, e, response)) {
                return;
            }

            captureException(e);
        }
    };
}

const THRESHOLD_PRODUCTS_LOAD = 60000;

/**
 * @param {Response} [response] express
 * @return {function(*, *): (Promise<void>|undefined)}
 */
export function getClientProducts(response) {
    return async(dispatch, getState) => {
        const state = getState();
        if (state.auth.isAuth === false) {
            return;
        }
        if (state.auth.isClientProductsLoading) {
            return;
        }

        const loaded = state.auth.clientProducts?.loaded;
        if (loaded) {
            const now = (new Date()).getTime();
            if ((now - loaded) < THRESHOLD_PRODUCTS_LOAD) {
                return;
            }
        }

        try {
            dispatch(clientProductsLoading(true));
            const productsInfo = await getProductsInfo(
                selectDomain(state),
                state.auth.accessToken,
            );
            dispatch(setClientProducts(productsInfo));
        } catch (e) {
            if (catch401(dispatch, e, response)) {
                return;
            }

            captureException(e);
        }
        dispatch(clientProductsLoading(false));
    };
}

const THRESHOLD_CONTACTS_LOAD = 60000;

/**
 * @param {Response} [response] express
 * @return {function(*, *): (Promise<void>|undefined)}
 */
export function getClientContacts(response) {
    return async(dispatch, getState) => {
        const state = getState();
        if (state.auth.isAuth === false) {
            return;
        }
        if (state.auth.isClientContactsLoading) {
            return;
        }

        const loaded = state.auth.clientContacts?.loaded;
        if (loaded) {
            const now = (new Date()).getTime();
            if ((now - loaded) < THRESHOLD_CONTACTS_LOAD) {
                return;
            }
        }

        try {
            dispatch(clientContactsLoading(true));
            const contactsInfo = await getContacts(
                selectDomain(state),
                state.auth.accessToken,
            );
            dispatch(setClientContacts(contactsInfo));
        } catch (e) {
            if (catch401(dispatch, e, response)) {
                return;
            }

            captureException(e);
        }
        dispatch(clientContactsLoading(false));
    };
}

export const createBalanceLimit = days => async(dispatch, getState) => {
    try {
        const state = getState();
        const { billingHost } = state.city.currentCity;
        const { isAuth, billingDomain } = state.auth;
        const billingHostname = billingDomain
            ? `https://${billingDomain}.db.ertelecom.ru`
            : billingHost;

        if (!isAuth) {
            return false;
        }

        const res = await billingXMLGetRequest(
            billingHostname,
            state.auth.accessToken,
            BILLING_GET_INFO,
            'create_balance_limit',
            {
                count_days: days,
            },
        );

        return !!(res.status === '1' &&
            res.data.create_balance_limit &&
            res.data.create_balance_limit.date_to);
    } catch (err) {
        console.error(err);
    }
};

export function checkCookie() {
    return (dispatch, getState) => {
        const state = getState();
        if (state.auth.isAuth) {
            const accessToken = cookie.load(ACCESS_TOKEN_COOKIE);
            if (accessToken == null || accessToken.trim().length === 0) {
                dispatch(logout());
            }
        }
    };
}

export const getClientContractPeriod = () => async(dispatch, getState) => {
    try {
        const state = getState();
        const domain = selectDomain(state);
        const accessToken = state.auth.accessToken;

        const { data } = await getContractPeriod(domain, accessToken);
        let contractPeriod;
        if (Array.isArray(data[0])) {
            contractPeriod = null;
        } else {
            contractPeriod = data[0];
            const res = await getPenaltySum(domain, accessToken);
            contractPeriod.penaltySum = res.data;
        }
        dispatch(setContractPeriods(parseContractPeriod(contractPeriod)));
    } catch (e) {
        console.error(e);
    }
};

export const parseContractPeriod = (contractPeriod) => ({
    activeFrom: contractPeriod.active_from,
    activeTo: contractPeriod.active_to,
    advType: contractPeriod.adv_type,
    discValue: contractPeriod.disc_value,
    duration: contractPeriod.duration,
    id: contractPeriod.id,
    name: contractPeriod.name,
    timeLeft: contractPeriod.time_left,
    penaltySum: contractPeriod.penaltySum
});

export const getReceiptInfo = () => async(dispatch, getState) => {
    try {
        const state = getState();
        const domain = selectDomain(state);
        const accessToken = state.auth.accessToken;
        const receiptInfo = await getReceiptJSON(domain, accessToken);

        dispatch(setReceiptInfo(receiptInfo));

    } catch (e) {
        captureException(e);
    }
};
